<template>
  <div class="start-image">
    <div class="info-text">
      <p>
        提示：启动页一般是一张固定展示企业名称、logo、宣传标语等内容的纵图；
      </p>
      <p>
        该图片尺寸为手机屏幕尺寸，由于手机品牌型号众多，为避免部分手机展示异常，您可根据常用品牌、机型配置多种尺寸的启动页图片；
      </p>
      <p>如不配置则默认一张白色底图，显示时间0.5s。</p>
    </div>
    <div class="tools-box">
      <div class="input-box">
        <span class="label">启动页停留时间</span>
        <Select v-model="time" @on-change="onChangeTime" :disabled="!$units.pointAction('systemSet_10_1')">
          <Option :value="0.5">0.5s</Option>
          <Option :value="1">1s</Option>
          <Option :value="1.5">1.5s</Option>
          <Option :value="2">2s</Option>
        </Select>
      </div>
      <Button
        v-show="$units.pointAction('systemSet_10_1')"
        type="primary"
        style="width: 80px"
        @click="$refs.startImageForm.open({})"
        >新增</Button
      >
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box" v-loading="loading">
      <Table :columns="columns" :data="tableData" row-key="id">
        <!-- 图片 -->
        <template slot-scope="{ row }" slot="img">
          <uploadNew
            v-model="row.imgUrl"
            :disabled="true"
            class="img-box"
          ></uploadNew>
        </template>
        <!-- 操作 -->
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="$refs.startImageForm.open(row)" v-show="$units.pointAction('systemSet_10_1')"
            >编辑</span
          >
          <span class="table-btn" @click="submitDelete(row)" v-show="$units.pointAction('systemSet_10_2')">删除</span>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page
        :total="total"
        :current="pageNo"
        :page-size="pageSize"
        show-total
        @on-change="pageChange"
        style="text-align: center"
      />
    </div>

    <start-image-form
      ref="startImageForm"
      :stopTime="time"
      :getTabList="getTabList"
    ></start-image-form>
  </div>
</template>
<script>
import uploadNew from "@/components/commons/uploadNew";
import startImageForm from "./components/startImageForm";
import filters from "@/api/filter";
export default {
  components: {
    startImageForm,
    uploadNew,
  },
  data: () => ({
    loading: false,
    time: 0.5,
    total: 0,
    pageNo: 1,
    pageSize: 10,
    tableData: [],
    columns: [],
  }),
  mounted() {
    this.columns = this.getTableColumns();
    if(!this.$units.pointAction('systemSet_10_1') && !this.$units.pointAction('systemSet_10_2')){
      this.columns.splice(this.columns.length-1, 1); 
    }

    this.getTabList();
    this.getStopTime();
  },
  methods: {
    getTableColumns() {
      const table = [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },

        {
          title: "图片",
          slot: "img",
          minWidth: 140,
          align: "center",
        },

        {
          title: "应用平台",
          minWidth: 200,
          align: "center",
          render(h, params) {
            const result = params.row.systemType;
            return <span>{result == "1" ? "iOS" : "Android"}</span>;
          },
        },
        {
          title: "尺寸",
          minWidth: 200,
          align: "center",
          key:'imgSize'
        },
        {
          title: '有效期',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            let effectTimeStart = params.row.effectTimeStart;
            let effectTimeEnd = params.row.effectTimeEnd;
            if(effectTimeStart && effectTimeEnd) {
              return <span>{ filters.filterTime(effectTimeStart, 'YYYY-MM-DD') } 至 { filters.filterTime(effectTimeEnd, 'YYYY-MM-DD') }</span>
            }else{
              return <span>长期有效</span>
            }
          }
        },
        {
          title: "操作",
          slot: "action",
          width: 120,
          align: "center",
        },
      ];
      return table;
    },

    // 切换轮播时间
    onChangeTime(value) {
      this.$http({
        url: "/buz/startupPageConfig/edit",
        type: "POST",
        data:{
          retentionTime:value
        },
        apiPermissionCode:'systemSet_10_1'
      }).then(res=>{
        this.getTabList();
      })
    },

    // 获取时间
    getStopTime() {
      this.$http({
        url: `/buz/startupPageConfig/retention`,
        type: "GET",
      }).then((res) => {
        this.time = res.data?res.data:this.time;
      });
    },

    // 获取列表数据
    getTabList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        type: "POST",
        url: "/buz/startupPageConfig/read/list",
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize
        },
        apiPermissionCode:'systemSet_10_0'
      }).then((res) => {
        this.total = res.total;
        this.tableData =
          res.data &&
          res.data.map((item) => {
            return {
              ...item,
              imgUrl: { path: item.imgUrl },
            };
          });
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 删除
    submitDelete(item) {
      this.$notice.inquiry("确认删除操作？").then(async () => {
        this.$http({
          url: `/buz/startupPageConfig/del?id=${item.id}`,
          type: "GET",
          apiPermissionCode:'systemSet_10_2'
        }).then((res) => {
          this.$Message.success("删除成功");
          this.getTabList();
        });
      });
    },
    
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getTabList();
    },
  },
};
</script>
<style lang='scss' scoped>
@import "./startImage.scss";
</style>